<template>
    <div class="team-settings">
        <div class="settings-item">
            <label class="settings-label">{{$t('TeamName')}}</label>
            <div class="settings-info">
                <div class="setting-name nowrap">{{c.name}}</div>
                <div v-if="c.member_role == 'admin' || c.member_role == 'creator'" @click="doset" class="setting-btn">{{$t('SetBtn')}}</div>
            </div>
        </div>
        <div class="settings-item">
            <label class="settings-label">{{$t('Mmanager')}}</label>
            <div class="settings-info">
                <div class="setting-name mbox nowrap">
                    <img v-for="(item,i) in c.members" :key="i" class="setting-member" :src="item.avatar" alt="">
                    <span class="setting-mlength">{{$t('MemberLength',{num:c.member_count})}}</span>
                </div>
                <div @click="checkTeam" class="setting-btn">{{$t('CheckBtn')}}</div>
            </div>
        </div>
        <div class="setting-footer">
            <div class="settings-item">
                <label @click="exit" class="delete-label">{{$t('ExitTeam')}}</label>
                <div class="delete-info">
                    <p>{{$t('DeleteTip')}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import Loading from '@/components/Loading'
export default {
    data(){
        return {
         }
    },
    components:{
        Loading
    },
    created(){

    },
    computed:{
        ...mapState('team',[
            'currentTeam'
        ]),
        ...mapState('user',[
            'id'
        ]),
        c(){
            return this.currentTeam
        }
    },
    methods:{
        ...mapMutations([
            'SHOW_DIALOG'
        ]),
        exit(){
            this.SHOW_DIALOG({
                title: this.$t('ExitTeam'),
                current: 'ExitTeam'
            })
        },
        doset(){
            this.SHOW_DIALOG({
                current: 'Rename',
                title: this.$t('Rename'),
                dialogData: {
                    tid: this.$route.params.tid,
                    from: 'Settings'
                }
            })
        },
        checkTeam(){
            this.SHOW_DIALOG({
                title: `${this.$t('TeamMember')}`,
                size: 'large',
                current: 'TeamShare',
                dialogData:{
                    tid: this.$route.params.tid
                }
            })
        }
        
    }
}
</script>

<style>
.team-settings{
    border-top: 1px solid #e7e9eb;
    padding-top: 30px;
}
.settings-item{
    padding: 0 10px;
    margin-bottom: 7px;
}
.settings-info{
    display: flex;
    justify-content: space-between;
    line-height: 40px;
}
.settings-label{
    font-size: 12px;
    color: #949aae;
}
.setting-btn{
    color: #2e68f8;
    cursor: pointer;
    white-space: nowrap;
    margin-left: 10px;
}
.setting-name.mbox{
    font-size: 0;
    flex: 1;
    display: flex;
    align-items: center;
}
.setting-member{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    vertical-align: middle;
    border: 2px solid #fff;
    margin-right: -8px;
}
.setting-mlength{
    margin-left: 14px;
    font-size: 14px;
    line-height: 40px;
    color: #949aae;
}
.setting-footer{
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e7e9eb;
}
.delete-label{
    line-height: 30px;
    color: #e97663;
    cursor: pointer;
}
.delete-info{
    font-size: 12px;
    color: #949aae;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/team/Settings.vue